import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdownButton", "checkbox", "label", "enrichmentBody", "icon"]
  static values = { visible: Boolean }

  connect() {
    this.updateButtonText()
  }

  handleCheckboxChange() {
    this.updateButtonText()
  }

  toggleEnrichmentBody() {
    if (this.visibleValue) {
      this.hideEnrichmentBody()
    } else {
      this.showEnrichmentBody()
    }
  }

  showEnrichmentBody() {
    this.enrichmentBodyTarget.classList.remove('d-none')
    this.iconTarget.classList.add('fa-rotate-180')
    this.visibleValue = true
  }

  hideEnrichmentBody() {
    this.enrichmentBodyTarget.classList.add('d-none')
    this.iconTarget.classList.remove('fa-rotate-180')
    this.visibleValue = false
  }

  updateButtonText() {
    const selectedLabels = this.getSelectedLabels()
    const buttonText = selectedLabels.length === 0
      ? "No columns selected"
      : selectedLabels.join(' · ')

    this.dropdownButtonTarget.textContent = buttonText
  }

  getSelectedLabels() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => this.findLabelForCheckbox(checkbox))
      .filter(label => label !== null)
  }

  findLabelForCheckbox(checkbox) {
    const label = this.labelTargets.find(label => label.getAttribute('for') === checkbox.id)
    return label ? label.textContent.trim() : null
  }
}
